module.exports = __webpack_public_path__ + "img/upload.97548a8f.gif";